import { Component } from '@angular/core';
import { NotificationService } from '../../../../service';

@Component({
  standalone: false,
  selector: 'trust-holders',
  templateUrl: './trust-holders.component.html'
})
export class TrustHoldersComponent {
  constructor(private notificationService: NotificationService) {}

  public notify(msg: [string, string]): void {
    this.notificationService.success(msg[0], msg[1]);
  }
}
